// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider[data-v-cec2d1a4]{display:flex;justify-content:space-between;margin-top:20px;align-items:flex-start;gap:5%;flex-wrap:nowrap}.divider>div[data-v-cec2d1a4]{flex-grow:1;flex-basis:fit-content;flex-shrink:0.5}.csv-hint[data-v-cec2d1a4]{font-size:12px;color:#666;margin-top:1em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
